export default __webpack_public_path__ + "static/media/pp_image.14bb38b3.png";